export async function getImageDataUrl(imageUrl: string) {
  if (imageUrl) {
    let blob = await fetch(imageUrl).then((r) => r.blob());
    let dataUrl = await new Promise((resolve) => {
      let reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
    return dataUrl as string;
  }
  return '';
}
